import { Map } from 'immutable';
import { createSelector } from 'reselect';

// For convenience, extract the ui section of the store.
const uiStoreSelector = state => state.get('ui');

const actionBarItemClickedSelector = createSelector(
  uiStoreSelector,
  uiStore => uiStore.get('actionBarItemClicked'),
);

// determine the type of assets favorites view the user has set
const assetsViewSelector = createSelector(
  uiStoreSelector,
  uiStore => uiStore.get('assetsView'),
);

// get the brand of the current application
const brandSelector = createSelector(
  uiStoreSelector,
  uiStore => uiStore.get('brand'),
);

// get the brand specific values, like the top nav image and the brand colors
const brandValuesSelector = createSelector(
  uiStoreSelector,
  uiStore => uiStore.get('brandValues') || Map(),
);

// get the brand logo of the current application
const brandLogoSelector = createSelector(
  brandValuesSelector,
  brandValues => brandValues.logo,
);

// determine the type of cases favorites view the user has set
const casesViewSelector = createSelector(
  uiStoreSelector,
  uiStore => uiStore.get('casesView'),
);

// get all the statuses of components if they are expanded
const componentsExpandedSelector = createSelector(
  uiStoreSelector,
  uiStore => uiStore.get('componentsExpanded'),
);

const hiddenWidgetsSelector = createSelector(
  uiStoreSelector,
  uiStore => uiStore.get('hiddenWidgets'),
);

// determine if the application should be rendered in full screen mode
const requestFullScreenModeSelector = createSelector(
  uiStoreSelector,
  uiStore => uiStore.get('requestFullScreenMode'),
);

// determine if print page is requested
const requestPrintPageSelector = createSelector(
  uiStoreSelector,
  uiStore => uiStore.get('requestPrintPage'),
);

// determine which (if any) left nav parents are currently expanded
const leftNavExpandedParentsSelector = createSelector(
  uiStoreSelector,
  uiStore => uiStore.get('leftNavExpandedParents'),
);

// get the status of left nav panel if it is expanded.
const leftNavExpandedSelector = createSelector(
  uiStoreSelector,
  uiStore => uiStore.get('leftNavExpanded'),
);

// determine if scrolling to unread note is necessary
const scrollToUnreadNoteSelector = createSelector(
  uiStoreSelector,
  uiStore => uiStore.get('scrollToUnreadNote'),
);

// determine the type of serviceRequests favorites view the user has set
const serviceRequestsViewSelector = createSelector(
  uiStoreSelector,
  uiStore => uiStore.get('serviceRequestsView'),
);

export {
  actionBarItemClickedSelector,
  assetsViewSelector,
  brandSelector,
  brandLogoSelector,
  brandValuesSelector,
  casesViewSelector,
  componentsExpandedSelector,
  hiddenWidgetsSelector,
  leftNavExpandedParentsSelector,
  leftNavExpandedSelector,
  requestPrintPageSelector,
  requestFullScreenModeSelector,
  scrollToUnreadNoteSelector,
  serviceRequestsViewSelector,
  uiStoreSelector,
};



// WEBPACK FOOTER //
// ./redux/ui/selectors.js